import ProductHeader from '../ProductHeader';
import { useProductList } from '../utils';
import SingleCard from '../SingleCard';
import { imgList } from './imgConfig';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';

import { ProductModule } from '@/components/MembersDay/type';

export interface BestSellersProps {
    title?: string;
    subtitle?: string;
    module: ProductModule;
}

const BestSellers = ({ title, subtitle, module }: BestSellersProps) => {
    const { locale } = getLocal();
    const { productList } = useProductList(module, locale);

    // 排除的id
    const exclude_productId = '7825964466330';
    const exclude_variantId = '43592212938906';
    const list = ['ca'].includes(locale)
        ? productList.filter((item) => {
              if (item.productId === exclude_productId && item.variantId === exclude_variantId) return false;
              return true;
          })
        : productList;

    const imgArr = imgList[locale];

    return (
        <div className={styled.BestSellers}>
            <ProductHeader title={title} subtitle={subtitle} />
            {list.map((item, index) => (
                <SingleCard
                    data={item}
                    title={title}
                    key={item.variantId}
                    right={index % 2 === 1}
                    usedPicPc={imgArr[index].pc}
                    usedPich5={imgArr[index].h5}
                    discount={item.discount}
                />
            ))}
        </div>
    );
};

export default BestSellers;
